import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
// import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
// import pin from "../../assets/Images/svg/pin.svg"
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import PushPinSharpIcon from '@mui/icons-material/PushPinSharp';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import { createSvgIcon } from '@mui/material/utils';
import { useTranslation } from "react-i18next";

const PinOffOutlinedIcon = createSvgIcon(
  <path d="M8 6.2V4H7V2h10v2h-1v8l2 2v2h-.2L14 12.2V4h-4v4.2L8 6.2zm12 14.5-1.3 1.3-5.9-5.9V22h-1.6v-6H6v-2l2-2v-.7L2 5.3 3.3 4 20 20.7zM8.8 14h1.8l-.9-.9-.9.9z" />,
  'PinOffOutlined'
);
const MessageInteraction = ({
  isRead,
  chatId,
  isPined,
  getChatList,
  archiveMessage,
  msgId,
  usermsgId,
  getArchivedList,
  getMessageList,
  UserId,
  // showClear, setShowClear,
  // showDelete, setShowDelete,
  toUserUId,
  setChatList,
}) => {
  // console.log(isPined);
  const sessionId = localStorage.getItem("sessionId");
  const toUserUID = localStorage.getItem("toUserUid");
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const { t } = useTranslation();
  const [showDelete, setShowDelete] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const language = localStorage.getItem("Lang");

  const buildFullUserChatPayload = (extra = {}) => ({
    deviceType: "Web",
    sessionId: sessionId,
    msgID: usermsgId || msgId,
    toUserUid: toUserUId || UserId || toUserUID,
    langKey: language === "en" ? "" : language,
    ...extra,
  });

  const deleteFullUserChat = (url, payload) =>
    axios({
      method: "delete",
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  //************************Archive Chat ************************//
  const ArchiveChat = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      // msgID: msgId,
      msgID: usermsgId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Message/ArchiveChat`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        getArchivedList();
        getMessageList({ forceRefresh: true });
      });
    } catch (e) {
      console.log(e);

      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Archive Chat End  ************************//

  //************************UnArchive Chat ************************//
  const UnArchiveChat = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      msgID: msgId,
            langKey: language === "en" ? "" : language,

      // msgID: usermsgId,
    };
    try {
      await axios.post(`Message/UnArchiveChat`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        getArchivedList();
        getMessageList({ forceRefresh: true });
      });
    } catch (e) {
      console.log(e);

      // if (e.response && e.response.status === 404) {
      //   setWarningToastMessage(e.response.data.message);
      //   setShowWarningToast(true);
      // } else {
      //   setErrorToastMessage(e.response.data.message);
      //   setShowErrorToast(true);
      // }
    }
  };
  //************************UnArchive Chat End  ************************//
  //************************PinChat Chat ************************//
  const PinChat = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      // msgID: msgId,
      msgID: usermsgId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Message/PinMessage`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        getArchivedList();
        getMessageList({ forceRefresh: true });
      });
    } catch (e) {
      console.log(e);

      // if (e.response && e.response.status === 404) {
      //   setWarningToastMessage(e.response.data.message);
      //   setShowWarningToast(true);
      // } else {
      //   setErrorToastMessage(e.response.data.message);
      //   setShowErrorToast(true);
      // }
    }
  };
  //************************PinChat Chat End  ************************//

  //************************UnPinChat Chat ************************//
  const UnPinChat = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      // msgID: msgId,
      msgID: usermsgId,
            langKey: language === "en" ? "" : language,

    };
    try {
      await axios.post(`Message/UnPinMessage`, responseData).then((res) => {
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        getArchivedList();
        getMessageList({ forceRefresh: true });
      });
    } catch (e) {
      console.log(e);

      // if (e.response && e.response.status === 404) {
      //   setWarningToastMessage(e.response.data.message);
      //   setShowWarningToast(true);
      // } else {
      //   setErrorToastMessage(e.response.data.message);
      //   setShowErrorToast(true);
      // }
    }
  };
  //************************UnPinChat Chat End  ************************//


  //************************Delete Chat start  ************************//
  // const [showDelete, setShowDelete] = useState(false);
  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const DeleteChat = async () => {
    const responseData = buildFullUserChatPayload({ forEveryOne: false });
    console.log("Delete Data===>", responseData);
    try {
      await deleteFullUserChat(`Message/DeleteFullUserChat`, responseData)
        .then((res) => {
          setShowDelete(!showDelete);
          //   toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          getArchivedList();
          getMessageList({ forceRefresh: true });
          if (typeof setChatList === "function") {
            setChatList([]);
          }
        });
    } catch (e) {
      console.log(e);

      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Delete Post End  ************************//
  //************************Delete Chat start  ************************//
  const handleClearClose = () => {
    setShowClear(false);
  };

  const ClearChat = async () => {
    const responseData = buildFullUserChatPayload();
    try {
      await deleteFullUserChat(`Message/ClearFullUserChat`, responseData)
        .then((res) => {
          setShowClear(!showClear);
          //   toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          handleClearClose();
          getArchivedList();
          getMessageList({ forceRefresh: true });
          getChatList({ forceRefresh: true });
          if (typeof setChatList === "function") {
            setChatList([]);
          }

        });
    } catch (e) {
      console.log(e);
      // handleClearClose();

      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Delete Post End  ************************//

  useEffect(() => {
    if (showDelete || showClear) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [showDelete, showClear]);
  return (
    <>
      <div
        className={`postMenu pointer${showDropdown ? " menu-open" : ""}`}
        onClick={() => setShowDropdown(!showDropdown)}
      >

        <MoreHorizSharpIcon className="material-symbols-sharp" />
        {showDropdown && (
          <Dropdown.Menu
            show={showDropdown}
            ref={dropdownRef}
            className="InteractionModal"
          >
            {archiveMessage === false ? (
              <Dropdown.Item as="button" className="dropdownList">
                <Link
                  onClick={() => {
                    ArchiveChat();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <ArchiveOutlinedIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Notifications.Archive Chat")}</span>
                  </div>
                </Link>
              </Dropdown.Item>
            ) : (
              <Dropdown.Item as="button" className="dropdownList">
                <Link
                  onClick={() => {
                    UnArchiveChat();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <UnarchiveOutlinedIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Notifications.UnArchive Chat")}</span>
                  </div>
                </Link>
              </Dropdown.Item>
            )}
            {/* jkjk */}

            {archiveMessage === false && isPined === false ? (
              <Dropdown.Item as="button" className="dropdownList">
                <Link
                  onClick={() => {
                    PinChat();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <PushPinSharpIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Notifications.Pin Chat")}</span>
                  </div>
                </Link>
              </Dropdown.Item>
            ) : isPined === true ? (
              <Dropdown.Item as="button" className="dropdownList">
                <Link
                  onClick={() => {
                    UnPinChat();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <PinOffOutlinedIcon className="material-symbols-sharp me-2" />
                    <span className="dropdownTxt f-14">{t("Notifications.UnPin Chat")}</span>
                  </div>
                </Link>
              </Dropdown.Item>
            ) : (
              ""
            )}

            <Dropdown.Item as="button" className="dropdownList">
              <Link
                onClick={() => {
                  setShowClear(!showClear);
                  toggleDropdown();
                }}
              >
                <div className="d-flex align-items-center">
                  <RemoveCircleOutlineOutlinedIcon className="material-symbols-sharp me-2" />
                  <span className="dropdownTxt f-14">{t("Notifications.Clear Message")}</span>
                </div>
              </Link>
            </Dropdown.Item>

            <Dropdown.Item as="button" className="dropdownList">
              <Link
                onClick={() => {
                  setShowDelete(!showDelete);
                  toggleDropdown();
                }}
              >
                <div className="d-flex align-items-center">
                  <DeleteOutlineSharpIcon className="material-symbols-sharp me-2" />
                  <span className="dropdownTxt f-14">{t("Notifications.Delete Message")}</span>
                </div>
              </Link>
            </Dropdown.Item>
          </Dropdown.Menu>
        )}
      </div>

      {/* <Modal
        show={show}
        size="md"
        centered
        onHide={handleDeleteClose}
        toggle={() => setShow(!show)}
        // className='modal-dialog-centered m'
      >
        <Modal.Header
          className="bg-transparent p-4"
          closeButton
          toggle={() => {
            setShow(!show);
          }}
        >
          <h6 className="f-16 fw-bold">
            Are you sure you want to Delete Chat?
          </h6>
        </Modal.Header>
        <Modal.Body className="text-center">
          <button color="" className="closebtn" onClick={() => DeleteChat()}>
            Delete
          </button>
        </Modal.Body>
      </Modal> */}

      {showDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("User Profile.Are You Sure You want to Delete?")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleDeleteClose();
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    DeleteChat();
                  }}
                >
                  {t("Drafts.Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {showClear && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are you sure you want to Clear Chat?")} </h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleClearClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    ClearChat();
                  }}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default MessageInteraction;
